import { createContext, useContext, useState, useCallback, ReactElement } from 'react';

interface UserSearchContextValue {
  searchString: string;
  setSearchString: (search: string) => void;
}

export const UserSearchContext = createContext<UserSearchContextValue>({
  searchString: '',
  setSearchString: () => {},
});

export function UserSearchContextProvider(props: { children: React.ReactNode }): ReactElement {
  const [searchString, setSearchString] = useState('');

  const setSearch = useCallback((search: string) => {
    setSearchString(search);
  }, []);

  return (
    <UserSearchContext.Provider value={{ searchString, setSearchString: setSearch }}>
      {props.children}
    </UserSearchContext.Provider>
  );
}

export const useUserSearchContext = (): UserSearchContextValue => useContext(UserSearchContext);
